import { useState, useEffect } from "react"
import { LangugeContext } from "./LangugeContext"
import "./main.css"
import { useParams } from 'react-router-dom'
import { language_ch, language_en } from "./language"

export default function LevelingInspection(props) {

    let { language } = useParams()
    if (!language) {
        language = "ch"
    }
    var languagePackage = language === "ch" ? language_ch : language_en

    return (
        <LangugeContext.Provider value={{ language, languagePackage }} >
            <div
                class="w-full h-full overflow-auto container p-5"
            >
                <p className=" text-gray-600 mt-5 text-sm">
                    使用小贴士：<br /><br />
                    1、更换相机请重新进行调平操作<br /><br />
                    2、俯仰前后和横滚检测时请保持设备回中静置<br /><br />
                    3、俯仰上下检测时请保持镜头朝向天空静置<br /><br />
                    4、航向检测时请保持手柄偏离垂直方向至少30°以上<br /><br />
                    5、检测时请确保云台开机处于非休眠或保护状态<br /><br />
                    6、单轴数值±20以下表明调平效果可用，越接近0云台越稳定<br /><br />
                    7、请单击“开始调平”跟随提示开始进行调平操作<br />
                </p>
            </div>
        </LangugeContext.Provider>
    )
}